/**
 * Verify Legitimacy — subsection 3 (repurpose /sframe-200)
 */

import { useParams } from 'react-router-dom';
import DebtReviewSectionShell, { type ChecklistItemDef } from './debts/DebtReviewSectionShell';

const VERIFY_ITEMS: ChecklistItemDef[] = [
  {
    id: 'verify-1',
    title: 'Verify Validity',
    description: 'Confirm each debt belongs to the decedent and is still owed.',
  },
  {
    id: 'verify-2',
    title: 'Check Statutes of Limitation',
    description: 'Identify any claims that may be time-barred.',
  },
  {
    id: 'verify-3',
    title: 'Audit Service Dates',
    description: "Match service dates against the decedent's medical and financial timeline.",
  },
];

export default function SFrame200() {
  const { estateId } = useParams<{ estateId: string }>();
  return (
    <DebtReviewSectionShell
      estateId={estateId}
      title="Verify Legitimacy"
      sectionIndex={3}
      checklistFrameId="sframe-199-s3"
      hubSectionKey="s3"
      items={VERIFY_ITEMS}
    />
  );
}
